import { IconName } from '@billy/design-system'
import { TFunction } from 'i18next'

import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { OnboardingUserIntent } from '../../../../../enums/onboardingUserIntent'
import { enabledEInvoicingCountries } from '../constants/enabledEInvoicingCountries'

interface IntentTileItem {
  icon: IconName
  id: OnboardingUserIntent
  label: string
}

export const getIntentTiles = (t: TFunction, organization?: Organization): IntentTileItem[] => {
  const isEInvoicingEnabled = enabledEInvoicingCountries.includes(organization?.countryId ?? '')

  return [
    {
      icon: 'filePen',
      id: OnboardingUserIntent.CreateInvoices,
      label: t('onboarding.steps.intent.invoices'),
    },
    {
      icon: 'chartColumnBig',
      id: OnboardingUserIntent.TrackExpenses,
      label: t('onboarding.steps.intent.expenses'),
    },
    ...(isEInvoicingEnabled
      ? ([
          {
            icon: 'fileKey',
            id: OnboardingUserIntent.ActivateEInvoices,
            label: t('onboarding.steps.intent.eInvoicing'),
          },
        ] as IntentTileItem[])
      : []),
    {
      icon: 'loaderPinwheel',
      id: OnboardingUserIntent.DiscoverAllFeatures,
      label: t('onboarding.steps.intent.discover'),
    },
  ]
}
